import { Component, ElementRef, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';
import { Table_Pcs, PcsFilterCriteria, PendingIntegeration } from 'src/app/common/models/PendingIntegeration';
import { Router } from '@angular/router';
import { constObj } from '../../common/Constants/constants';
import { forkJoin } from 'rxjs';
import { OpenLinkById } from '../../common/services/openlinkbyid';

@Component({
  selector: 'app-pendingcontent',
  templateUrl: './pendingcontent.component.html',
  styleUrls: ['./pendingcontent.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PendingcontentComponent implements OnInit, AfterViewInit {
  public displayedColumns = ["Standardssource", "Transitionguidanceparagraph", "Title", "Integrate"];
  public dataSource = new MatTableDataSource<Table_Pcs>();
  public dataSource2 = new MatTableDataSource<Table_Pcs>();
  pendingIntegeration: PendingIntegeration = new PendingIntegeration();
  actualresult: any;
  pagelistarray: any[] = [];
  span;
  isButton1;
  isButton2;
  isButton3;
  iscontinue;
  iscontinue2;
  pc_warning;
  pc_howToUseCod;
  pc_FAQ;
  pc_header;
  pc_limitations;
  pc_linkDescription;
  pc_beginningDate;
  pc_continue;
  pc_filingStatuslabel;
  pc_periodtypelabel;
  pc_Fillingstatus: string[];
  pc_periodtype: string[];
  fillingstatusdefault;
  periodtypedefault;
  pc_headerSpecialCases;
  pc_bodySpecialCases;
  pc_headerEarlyAdoptions;
  pc_bodyEarlyAdoptions;
  pc_bodySpecialCasesYes;
  pc_bodySpecialCasesNo;
  pc_bodyEarlyAdoptionsYes;
  pc_buttonSubmit;
  pc_bodyEarlyAdoptionsNo;
  pc_optionalInput;
  pc_enabled;
  pc_viewprofile;
  pc_clearprofile;
  pc_backtoTop;
  minDate: Date;
  maxDate: Date;
  DateError: string = "";
  FillingStatusError: string = "";
  PeriodTypeError: string = "";
  selectallyesSC = false;
  selectallyesEA = false;
  selectallnoSC = false;
  selectallnoEA = false;
  datePicked;
  fillingStatusPicked;
  periodTypePicked
  pendingContent: any[] = [];
  pcsFilterCriteria: PcsFilterCriteria = new PcsFilterCriteria();
  earlyAdoptionResult: any[]
  specialCasesResult: any[]
  pc_standardsSource: any;
  pc_integrate: any;
  pc_transitionParagraph: any;
  pc_yes: any;
  pc_no: any;
  pc_all: any;
  pc_none: any;
  pc_batchIntegration: any;
  generalFeedback: any = "General Feedback"
  yesOrNo: Array<string> = ['yes', 'no'];

  pendingContentFormGroup: FormGroup;
  PendingContentPageData = {
    pubId: "",
    pageId: "",
    paraId: ""
  };
  noRecords = constObj.Norecords;
  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private elementRef: ElementRef,
    private route: Router,
    private formBuilder: FormBuilder,
    private openLink: OpenLinkById
  ) { }

  ngAfterViewChecked() {
    var cdk_pane = Array.from(document.getElementsByClassName('cdk-overlay-pane') as HTMLCollectionOf<HTMLElement>)
    if (cdk_pane.length > 0) {
      var matSelectPanel = Array.from(document.getElementsByClassName('mat-select-panel') as HTMLCollectionOf<HTMLElement>)
      //matSelectPanel.forEach(x=>{
      //  x.style.minWidth = '100%';
      //})
      var datepicker = document.getElementById("datePicker");
      var offsetTop = datepicker.offsetTop;
      if (matSelectPanel.length == 0 && datepicker) {
        cdk_pane.forEach(x => {
          x.style.top = offsetTop + 42 + 'px';
          x.style.bottom = 'unset';
        })
      }

    }
     
  }

  radioButtonChange(){
   this.StorePCSData();
  }

  ngOnInit(): void {
    this.graphQlService.GetPendingContentAgreementSession().subscribe(data => {
      if (data == null || data.agreementValue == null || data.agreementValue == false) { this.route.navigateByUrl("/pendingcontentsystemagreement"); }
    })
    this.commonDataService.showLoader.next(true);
    this.pendingContentFormGroup = this.formBuilder.group({
      datePicker: ['', Validators.required],
      fillingstatusdefault: ['', Validators.required],
      periodtypedefault: ['', Validators.required]
    });
  
    this.isButton1 = true;
    this.isButton2 = false;
    this.isButton3 = false;
    this.getpendingcontentsystemLabel();

    this.iscontinue = false;
    this.iscontinue2 = false;
    this.getpcperiodtype();
    this.getpcfillingstatus();
    const currentYear = new Date().getUTCFullYear();
    const currentMonth = new Date().getUTCMonth();
    const currentDate = new Date().getUTCDate();
    this.minDate = new Date(currentYear - 3, currentMonth, currentDate);
    this.maxDate = new Date(currentYear + 3, currentMonth, currentDate);

    this.EditPCSPrefillValues();
  }

  getAllSpecialCases() {
    this.getPendingContent();

  }
  selectedRow;

  radioSelected() {
    console.log(this.selectedRow);
  }

  getAllEarlyAdoptions() {
    this.MapEarlyAdoption(2);
  }
  ViewProfile() {
    this.route.navigateByUrl("/pendingcontentintegeration");
  }
  Reset() {
    this.isButton1 = true;
    this.iscontinue = false;
    this.isButton2 = false;
    this.isButton3 = false;
    this.iscontinue2 = false;
    this.SC_Checked = 0;
    this.dataSource = new MatTableDataSource<Table_Pcs>();
    this.dataSource2 = new MatTableDataSource<Table_Pcs>();
    this.pendingContentFormGroup.controls["datePicker"].enable();
    this.pendingContentFormGroup.controls["fillingstatusdefault"].enable();
    this.pendingContentFormGroup.controls["periodtypedefault"].enable();
    this.pendingContentFormGroup = this.formBuilder.group({
      datePicker: ['', Validators.required],
      fillingstatusdefault: ['', Validators.required],
      periodtypedefault: ['', Validators.required]
    });
    this.graphQlService.SetPCSIntegratedFlag(false).subscribe();
    this.isPCSIntegrated = false;
    localStorage.setItem("isPendingContentPage", String(this.isPCSIntegrated));
    // localStorage.removeItem("PCSIntegratedData");
  }
  isPCSIntegrated: boolean = false;
  editPCS: boolean = false;
  isPCSIntegratedFromBackButton: boolean = false;
  EditPCSPrefillValues() {

    this.graphQlService.GetPCSIntegratedFlag().subscribe(data => {
      if (data) {
        this.isPCSIntegrated = data;
        localStorage.setItem("isPendingContentPage", String(this.isPCSIntegrated));
        //this.commonDataService.EditFromContentPage.subscribe(edit => {
          // this.editPCS = edit;
          this.editPCS = true;
          //if (edit) {
          this.graphQlService.GetPendingIntegrationSession().subscribe(res => {
            if(res){
            let setDate = new Date(res.selectedDate);
            this.datePicked = setDate;
            this.pendingContentFormGroup.patchValue({
              datePicker: this.datePicked,
              fillingstatusdefault: res.selectedFillingStatus,
              periodtypedefault: res.selectedPeriodType
            });

            if (this.datePicked !== "" && this.datePicked !== undefined && this.fillingStatusPicked != "" && this.periodTypePicked != "") {
              if (this.isValidDate(this.datePicked)) {
                this.DateError = "";
                this.pendingContentFormGroup.controls["datePicker"].enable();
                this.pendingContentFormGroup.controls["fillingstatusdefault"].enable();
                this.pendingContentFormGroup.controls["periodtypedefault"].enable();
                if(localStorage.getItem("isPCSTableUpdated")=='true'){
                  let pendingcontentData=JSON.parse(localStorage.getItem("PCSIntegratedData"));
                  this.dataSource.data = pendingcontentData.PcsData.specialCases as Table_Pcs[];
                  this.dataSource2.data = pendingcontentData.PcsData.earlyAdoption as Table_Pcs[];
                }
                else{
                  this.dataSource.data = res.specialCases as Table_Pcs[];
                  this.dataSource2.data = res.earlyAdoption as Table_Pcs[];
                }
                this.earlyAdoptionResult = res.earlyAdoption.sort((a, b) => (a.title?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.title?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? 1 : -1);
                this.specialCasesResult = res.specialCases.sort((a, b) => (a.title?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.title?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? 1 : -1);

                this.continuepc(this.isPCSIntegrated)
              }
            }
          }
          //})
          //}
        })
      }
      else{
        let pendingcontentData=JSON.parse(localStorage.getItem("PCSIntegratedData"));
        if(localStorage.getItem("IntegratePendingContent")=="true" && pendingcontentData){
          this.isPCSIntegratedFromBackButton=true;
          let setDate = new Date(pendingcontentData.PcsData.selectedDate)
          this.datePicked = setDate;
          this.pendingContentFormGroup.patchValue({
            datePicker: this.datePicked,
            fillingstatusdefault: pendingcontentData.PcsData.selectedFillingStatus,
            periodtypedefault: pendingcontentData.PcsData.selectedPeriodType
          });
          this.editPCS = true;
          this.continuepc(this.isPCSIntegratedFromBackButton);
          this.dataSource.data = pendingcontentData.PcsData.specialCases as Table_Pcs[];
          this.specialCasesResult=pendingcontentData.SCRawData;
          if(pendingcontentData.PcsData.earlyAdoption.length!=0 && pendingcontentData.isEA_Enabled){
            this.dataSource2.data = pendingcontentData.PcsData.earlyAdoption as Table_Pcs[];
          }
          else{
            this.isButton1 = false;
            this.isButton2 = true;
            this.isButton3 = true;
            this.iscontinue2 = false;
            this.earlyAdoptionResult = pendingcontentData.EARawData;
            this.dataSource2 = new MatTableDataSource<Table_Pcs>();
          }
          localStorage.setItem("IntegratePendingContent","false");
        }
      }
    })
    //this.commonDataService.EditFromContentPage.subscribe(res => {
    //  if (res == true) {
    //    let data = JSON.parse(localStorage.getItem("PCSInput"));
    //    let setDate = new Date(data.Date);
    //    this.datePicked = setDate;
    //    this.pendingContentFormGroup.patchValue({
    //      datePicker: this.datePicked,
    //      fillingstatusdefault: data.fillingStatus,
    //      periodtypedefault: data.periodType
    //    });
    //  }
    //})
  }
  public ngAfterViewInit() {
    this.span = this.elementRef.nativeElement.querySelectorAll('span');
    this.span = document.getElementById('pccontent')?.getElementsByTagName("span") as HTMLCollectionOf<HTMLElement>;
  }
  SC_Checked: number;
  EA_Checked: number;
  ngAfterContentChecked() {
    var yes_sc_exists = this.dataSource.data.filter(x => x.yesOrNo == 1);
    var no_sc_exists = this.dataSource.data.filter(x => x.yesOrNo == 2);
    if ((yes_sc_exists.length > 0 && no_sc_exists.length > 0)) {
      this.SC_Checked = 0;
    }

    var yes_ea_exists = this.dataSource2.data.filter(x => x.yesOrNo == 1);
    var no_ea_exists = this.dataSource2.data.filter(x => x.yesOrNo == 2);
    if (yes_ea_exists.length > 0 && no_ea_exists.length > 0) {
      this.EA_Checked = 0;
    }
    else if (this.dataSource2.data.length == 1 && yes_ea_exists.length == 1 && no_ea_exists.length == 0) {
      this.EA_Checked = 1;
    }
    else if (this.dataSource2.data.length == 1 && yes_ea_exists.length == 0 && no_ea_exists.length == 1) {
      this.EA_Checked = 2;
    }
  }
  pendingintegeration() {
    this.commonDataService.showLoader.next(true);
    this.pendingIntegeration.selectedDate = this.pendingContentFormGroup.controls.datePicker.value.toDateString();
    this.pendingIntegeration.selectedFillingStatus = this.pendingContentFormGroup.controls.fillingstatusdefault.value;
    this.pendingIntegeration.selectedPeriodType = this.pendingContentFormGroup.controls.periodtypedefault.value;
    this.pendingIntegeration.specialCases = this.dataSource.data;
    this.pendingIntegeration.earlyAdoption = this.dataSource2.data;
    this.pendingIntegeration.integrationStatus = [];
    this.graphQlService.SetPendingIntegrationSession(this.pendingIntegeration, true).subscribe(data => {
      this.commonDataService.pendingIntegeration.next(this.pendingIntegeration);
      localStorage.setItem("isPCSTableUpdated","false");
      this.commonDataService.showLoader.next(false);
      localStorage.setItem("isPendingContentPage", 'true');
      this.route.navigateByUrl("/pendingcontentintegeration");
    });

  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.DateError = "";
    this.isValidDate(this.pendingContentFormGroup.controls.datePicker.value)
  }

  isValidDate(d) {
    if (d instanceof Date) {
      const selectedDate = new Date(d);
      if (selectedDate < this.minDate || selectedDate > this.maxDate) {
        this.DateError = "You must enter a valid date (format 'MM/DD/YYYY'). Date can be prior to, or 3 years from, today's date."
        return false;
      }
    }
    else {
      this.DateError = "Please Enter Fiscal Year Beginning Date in valid format (MM/DD/YYYY)."
      return false;
    }
    this.DateError = ""
    return true;
  }
  OpenRightOverlay(element: any) {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.PendingContentPageData = { pubId: element.transitionGuidanceParagraphPubId, pageId: element.transitionGuidanceParagraphTopicId, paraId: element.paragraph };
    this.commonDataService.rightOverlayOption.next("PendingContentviewer");
    this.commonDataService.rightOverlayPendingContentData.next(this.PendingContentPageData);

    this.StorePCSData();
  }

  StorePCSData(){
    this.pendingIntegeration.selectedDate = this.pendingContentFormGroup.controls.datePicker.value.toDateString();
    this.pendingIntegeration.selectedFillingStatus = this.pendingContentFormGroup.controls.fillingstatusdefault.value;
    this.pendingIntegeration.selectedPeriodType = this.pendingContentFormGroup.controls.periodtypedefault.value;
    this.pendingIntegeration.specialCases = this.dataSource.data;
    this.pendingIntegeration.earlyAdoption = this.dataSource2.data;
    this.pendingIntegeration.integrationStatus = [];

    let obj={
      PcsData:this.pendingIntegeration,
      isEA_Enabled:this.iscontinue2,
      EARawData:this.earlyAdoptionResult,
      SCRawData:this.specialCasesResult,
    };
    localStorage.setItem("PCSIntegratedData", JSON.stringify(obj));
    localStorage.setItem("isPCSTableUpdated","true");
  }

  getpendingcontentsystemLabel() {
    this.graphQlService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.pc_header = labels.filter(x => x.key == "pc_header").map(y => y.value);
        this.pc_warning = labels.filter(x => x.key == "pc_warning").map(y => y.value);
        this.pc_FAQ = labels.filter(x => x.key == "pc_FAQ").map(y => y.value);
        this.pc_continue = labels.filter(x => x.key == "pc_continue").map(y => y.value);
        this.pc_limitations = labels.filter(x => x.key == "pc_limitations").map(y => y.value);
        this.pc_howToUseCod = labels.filter(x => x.key == "pc_howToUseCod").map(y => y.value);
        this.pc_beginningDate = labels.filter(x => x.key == "pc_beginningDate").map(y => y.value);
        this.pc_filingStatuslabel = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.pc_periodtypelabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.pc_linkDescription = labels.filter(x => x.key == "pc_linkDescription").map(y => y.value);
        this.pc_headerSpecialCases = labels.filter(x => x.key == "pc_headerSpecialCases").map(y => y.value);
        this.pc_bodySpecialCases = labels.filter(x => x.key == "pc_bodySpecialCases").map(y => y.value);
        this.pc_headerEarlyAdoptions = labels.filter(x => x.key == "pc_headerEarlyAdoptions").map(y => y.value);
        this.pc_bodyEarlyAdoptions = labels.filter(x => x.key == "pc_bodyEarlyAdoptions").map(y => y.value);
        this.pc_buttonSubmit = labels.filter(x => x.key == "pc_buttonSubmit").map(y => y.value);
        this.pc_bodySpecialCasesYes = labels.filter(x => x.key == "pc_bodySpecialCasesYes").map(y => y.value);
        this.pc_bodySpecialCasesNo = labels.filter(x => x.key == "pc_bodySpecialCasesNo").map(y => y.value);
        this.pc_bodyEarlyAdoptionsYes = labels.filter(x => x.key == "pc_bodyEarlyAdoptionsYes").map(y => y.value);
        this.pc_bodyEarlyAdoptionsNo = labels.filter(x => x.key == "pc_bodyEarlyAdoptionsNo").map(y => y.value);
        this.pc_optionalInput = labels.filter(x => x.key == "pc_optionalInput").map(y => y.value);
        this.pc_standardsSource = labels.filter(x => x.key == "pc_standardsSource").map(y => y.value);
        this.pc_transitionParagraph = labels.filter(x => x.key == "pc_transitionParagraph").map(y => y.value);
        this.pc_integrate = labels.filter(x => x.key == "pc_integrate").map(y => y.value);
        this.pc_yes = labels.filter(x => x.key == "pc_yes").map(y => y.value);
        this.pc_no = labels.filter(x => x.key == "pc_no").map(y => y.value);
        this.pc_batchIntegration = labels.filter(x => x.key == "pc_batchIntegration").map(y => y.value);
        this.pc_all = labels.filter(x => x.key == "pc_all").map(y => y.value);
        this.pc_none = labels.filter(x => x.key == "pc_none").map(y => y.value);
        this.pc_enabled = labels.filter(x => x.key == "pc_enabled").map(y => y.value);
        this.pc_viewprofile = labels.filter(x => x.key == "pc_viewprofile").map(y => y.value);
        this.pc_clearprofile = labels.filter(x => x.key == "pc_clearprofile").map(y => y.value);
        this.pc_backtoTop = labels.filter(x => x.key == "pc_backtoTop").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  getPendingContent() {
    this.commonDataService.showLoader.next(true);
    this.pcsFilterCriteria.Date = this.pendingContentFormGroup.controls.datePicker.value;
    this.pcsFilterCriteria.filingStatus = this.pendingContentFormGroup.controls.fillingstatusdefault.value;
    this.pcsFilterCriteria.periodType = this.pendingContentFormGroup.controls.periodtypedefault.value;
    this.commonDataService.PCSFilterCriteria.next(this.pcsFilterCriteria);
    forkJoin(this.graphQlService.getSpecialCase(), this.graphQlService.getEarlyAdoption(this.pcsFilterCriteria)).subscribe(([specialCaseRes, earlyAdoptionRes]) => {
      this.earlyAdoptionResult = earlyAdoptionRes.sort((a, b) => (a.source?.title?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.source?.title?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? 1 : -1);
      this.specialCasesResult = specialCaseRes.sort((a, b) => (a.source?.title?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.source?.title?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? 1 : -1);
      this.mapSpecialCases(2);
      this.StorePCSData();
      this.iscontinue = true;
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  mapSpecialCases(yesorNo) {
    var response: any;
    var res: any[] = [];
    for (let i in this.specialCasesResult) {
      var id = this.specialCasesResult[i].id
      var result = this.isPCSIntegrated ? this.specialCasesResult[i] : this.specialCasesResult[i].source
      response = this.isPCSIntegrated ? this.mapExisitingValues(result, yesorNo) : this.mapValuesWithTable(id, result, yesorNo);
      res.push(response);
    }
    this.dataSource.data = res as Table_Pcs[]
  }
  mapExisitingValues(result, yesorNo) {
    result.yesOrNo = yesorNo
    return result;
  }
  MapEarlyAdoption(yesorNo) {
    var response: any;
    var res: any[] = [];
    for (let i in this.earlyAdoptionResult) {
      var id = this.earlyAdoptionResult[i].id
      var result = this.isPCSIntegrated ? this.earlyAdoptionResult[i] : this.earlyAdoptionResult[i].source
      response = this.isPCSIntegrated ? this.mapExisitingValues(result, yesorNo) : this.mapValuesWithTable(id, result, yesorNo);
      res.push(response);
    }
    this.dataSource2.data = res as Table_Pcs[]
  }
  mapValuesWithTable(id, result, yesorNo) {
    return {
      standardsource: result.standardUpdatePdfName,
      transistionguidance: result.transitionGuidanceTopicNum + '-' + result.transitionGuidanceSubtopicNum + '-' + result.transitionGuidanceParagraphNum,
      yesOrNo: yesorNo,
      id: id,
      standsourcepdffileName: result.standardUpdatePdfFilename?.trimStart().trimEnd(),
      title: result.title?.trimStart().trimEnd(),
      //body: result.titleBody.substring(result.titleBody.indexOf(standardsource + ", ") + 1),
      body: result.titleBody.substring(result.titleBody.indexOf(", ") + 1),
      filingStatus: this.pendingContentFormGroup.controls.fillingstatusdefault.value,
      periodType: this.pendingContentFormGroup.controls.periodtypedefault.value,
      standardSourcePubId: result.standardUpdateContentPubId,
      standardSourceId: result.id,
      topic: result.transitionGuidanceTopicNum,
      supbtopic: result.transitionGuidanceSubtopicNum,
      section: result.transitionGuidanceSectionNum,
      paragraph: result.transitionGuidanceParagraphNum,
      transitionGuidanceParagraphPubId: result.transitionGuidanceParagraphPubId,
      transitionGuidanceParagraphTopicId: result.transitionGuidanceParagraphTopicId,
      date: result.rolloffDate,
    };

  }
  getpcfillingstatus() {
    this.graphQlService.getPCFillingStatus().subscribe(data => {
      if (data != "") {
        this.pc_Fillingstatus = data.content.data.listItem;
        this.fillingstatusdefault = new FormControl(this.pc_Fillingstatus[0]);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  gotoSection() {
    document.getElementById('scrollToTop').scrollIntoView();
  }
  getpcperiodtype() {
    this.graphQlService.getPCPeriodType().subscribe(data => {
      if (data != "") {
        this.pc_periodtype = data.content.data.listItem;
        this.periodtypedefault = new FormControl(this.pc_periodtype[0]);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openLinkById(event) {
    this.openLink.openLinkById(event);
  }
  submitfromEdit() {
    this.iscontinue2 = false
    this.dataSource = new MatTableDataSource<Table_Pcs>();
    this.dataSource2 = new MatTableDataSource<Table_Pcs>();
    this.commonDataService.EditFromContentPage.next(false);
    this.editPCS = false;
    this.isPCSIntegrated = false;
    localStorage.setItem("isPendingContentPage", String(this.isPCSIntegrated));
    this.graphQlService.SetPCSIntegratedFlag(false).subscribe(data => this.continuepc(false));
  }
  continuepc(isPCSIntegrated) {
    this.datePicked = this.pendingContentFormGroup.controls.datePicker.value;
    this.fillingStatusPicked = this.pendingContentFormGroup.controls.fillingstatusdefault.value;
    this.periodTypePicked = this.pendingContentFormGroup.controls.periodtypedefault.value;
    if (this.datePicked !== "" && this.datePicked !== undefined && this.fillingStatusPicked != "" && this.periodTypePicked != "") {
      if (this.isValidDate(this.datePicked)) {
        this.DateError = "";
        this.isButton1 = false;
        // this.iscontinue = true;
        this.isButton2 = true;
        this.isButton3 = false;
        if (!this.editPCS) {
          this.pendingContentFormGroup.controls["datePicker"].disable();
          this.pendingContentFormGroup.controls["fillingstatusdefault"].disable();
          this.pendingContentFormGroup.controls["periodtypedefault"].disable();
        }
        if (isPCSIntegrated) { this.iscontinue = true; this.continuepc2(isPCSIntegrated) } else { this.getAllSpecialCases(); }
        
      }
    }
    else {
      if (this.datePicked === "" || this.datePicked === undefined) {
        this.DateError = "Please Enter Fiscal Year Beginning Date."
      }
      if (this.fillingStatusPicked == "") {
        this.FillingStatusError = "Please select Filling Status.";
      }
      if (this.periodTypePicked == "") {
        this.PeriodTypeError = "Please select Period Type.";
      }
    }
  }

  onPeriodTypeChange(obj) {
    this.periodTypePicked = this.pendingContentFormGroup.controls.periodtypedefault.value;
    if (this.periodTypePicked != "") {
      this.PeriodTypeError = "";
    }
    else {
      this.PeriodTypeError = "Please select Period Type.";
    }
  }


  onFillingStatusChange(obj) {
    this.fillingStatusPicked = this.pendingContentFormGroup.controls.fillingstatusdefault.value;
    if (this.fillingStatusPicked != "") {
      this.FillingStatusError = "";
    }
    else {
      this.FillingStatusError = "Please select Filling Status.";
    }
  }

  continuepc2(isPCSIntegrated) {
    this.isButton1 = false;
    this.isButton2 = false;
    this.iscontinue2 = true;
    this.isButton3 = true;
    if (!isPCSIntegrated) { this.getAllEarlyAdoptions() }

  }
  CheckAll(value, tab) {
    if (tab == "SpecialCases") {
      if (value == "yes") {
        this.mapSpecialCases(1);
      }

      else if (value == "no") {
        this.mapSpecialCases(2);
      }
    } else if (tab == "EarlyAdoptions") {
      if (value == "yes") {
        this.MapEarlyAdoption(1);
      }
      else if (value == "no") {
        this.MapEarlyAdoption(2);
      }
    }
  }
}

